<br>
<form id="pesticideForm" #pesticideForm="ngForm">
  <div class="p-grid">
    <div class="p-col-12 columnPadding">
      <h4>Pesticide Application Record</h4>
    </div>
  </div>
  @if (record) {
  <div class="md:p-grid sm:container">
    <div class="sm:row">
      <div class="sm:col md:p-col-4">
        <h6>Applicator</h6>
        <ng-select class="custom" required [items]="employees" placeholder="Select an Applicator" [selectOnTab]="true"
          (ngModelChange)="onApplicatorSelect($event)" name="applicator" bindLabel="fullName"
          [(ngModel)]="record.applicator">
        </ng-select>
      </div>
      <div class="sm:col md:p-col-4">
        <h6>Certified Applicator</h6>
        <ng-select class="custom" required [items]="employees" placeholder="Select a Certified Applicator"
          [selectOnTab]="true" (ngModelChange)="onCertifiedApplicatorSelect($event)" name="certifiedApplicator"
          bindLabel="fullName" [(ngModel)]="record.certifiedApplicator">
        </ng-select>
      </div>
      <div class="sm:col md:p-col-4">
        <h6>Date</h6>
        <p-datepicker name="date" [(ngModel)]="record.dateApplied" class="secondary" [style]="{'width':'100%'}"
          [inputStyle]="{'width':'100%', 'border-radius': '5px'}"></p-datepicker>
      </div>
    </div>
    <div class="sm:row">
      <div class="sm:col md:p-col-4">
        <h6>Chemical</h6>
        <ng-select class="custom" required [items]="chemicals" placeholder="Select a Chemical" [selectOnTab]="true"
          (ngModelChange)="onChemicalSelect($event)" name="chemical" bindLabel="dropdown" [(ngModel)]="record.chemical">
        </ng-select>
      </div>
      <div class="sm:col md:p-col-4">
        <h6>Application Method</h6>
        <ng-select class="custom" required [items]="chemicalAppMethods" placeholder="Select an Application Method"
          [selectOnTab]="true" (ngModelChange)="onChemicalAppMethodSelect($event)" name="chemicalAppMethod"
          bindLabel="method" [(ngModel)]="record.chemicalApplicationMethod">
        </ng-select>
      </div>
      <div class="sm:col md:p-col-4">
        <h6>Application Location / Treated Area</h6>
        <ng-select class="custom" required [items]="chemicalAppLocations" placeholder="Select an Application Location"
          [selectOnTab]="true" (ngModelChange)="onChemicalAppLocationSelect($event)" name="chemicalAppLocation"
          bindLabel="location" [(ngModel)]="record.chemicalApplicationLocation">
        </ng-select>
      </div>
    </div>
    <div class="sm:row">
      <div class="sm:col md:p-col-4">
        <h6>Total Amount Used (Concentrate)</h6>
        <input pInputText name="amountConcentrate" [(ngModel)]="record.amountConcentrateUsed" required />
      </div>
      <div class="sm:col md:p-col-4">
        <h6>Total Volume (If Diluted)</h6>
        <input pInputText name="totalVolume" [(ngModel)]="record.totalVolume" />
      </div>
      <div class="sm:col md:p-col-4">
        <h6>Wind Direction and Speed (MPH)</h6>
        <input pInputText name="windDirectionAndSpeed" [(ngModel)]="record.windDirectionAndSpeed" required />
      </div>
    </div>
    <div>
      <div>
        <div class="sm:col md:p-col-4">
          <h6>Temperature (F)</h6>
          <input pInputText name="temperature" [(ngModel)]="record.temperature" required />
        </div>
      </div>
    </div>
    <div class="sm:row">
      <div class="sm:col md:p-col-4">
        <h6>Start</h6>
        <input pInputText type="time" name="startTime" [(ngModel)]="startTimeString" required>
      </div>
      <div class="sm:col md:p-col-4">
        <h6>End</h6>
        <input pInputText type="time" name="endTime" [(ngModel)]="endTimeString" required>
      </div>
    </div>
    <div class="sm:col md:p-col-4">
      <h6>Work Order Customer and Address</h6>
      <app-basic-work-order-dropdown [disabled]="disableWorkOrderSelect"
        [existingSelectionQuoteNumber]="record.quoteNumber" [required]="true" (workOrderSelected)="setWorkOrder($event)">
      </app-basic-work-order-dropdown>
    </div>
  </div>
  }
  <app-loading-swirly [isLoading]="!record"></app-loading-swirly>
  <div class="row-container" style="flex-direction: row-reverse;">
    <div>
      @if (pesticideForm.invalid && pesticideForm.submitted) {
      <div class="alert alert-danger" role="alert">
        There are errors on this page. Please correct the errors and resubmit.
      </div>
      }
    </div>
    @if (!wellnessWorkOrderId && !recordId) {
    <div>
      <p-button type="submit" severity="primary" label="Save" (click)="saveNewRecord(pesticideForm)">
      </p-button>
      <p-button type="button" severity="warn" label="Cancel" (click)="goToList()">
      </p-button>
    </div>
    }
    @if (recordId) {
    <div>
      <p-button type="button" label="Delete" severity="danger" (click)="delete()">
      </p-button>
      <p-button type="button" severity="warn" label="Cancel" (click)="goToList()">
      </p-button>
      <p-button type="submit" severity="primary" label="Save" (click)="saveEditedRecord(pesticideForm)">
      </p-button>
    </div>
    }
    @if (wellnessWorkOrderId) {
    <div>
      <p-button type="submit" severity="primary" [disabled]="disableSave" label="Save and Return to Work Order"
        (click)="saveRecordAndReturnToWorkOrder(pesticideForm)">
      </p-button>
      <p-button type="button" severity="warn" label="Cancel" (click)="goToWorkOrder()">
      </p-button>
    </div>
    }
  </div>
</form>